<script setup lang="ts">
import { useDropzone } from 'vue3-dropzone'
import {$t} from "@/service/CommonHelper";

const props = defineProps({
  label: String,
  options: Object
})

const emit = defineEmits<{
  (e: 'change', files: File[]): void
  (e: 'reject', files: unknown[]): void
}>()

const onDrop = (accepted: File[], rejected: any) => {
  if (rejected?.length) {
    emit('reject', rejected)
  }
  emit('change', accepted)
}

const dropzone = useDropzone({
  onDrop,
  ...props.options
})
</script>

<template>
  <div class="download-form">
    <div class="download-form__container" id="drop-area"  v-bind="dropzone.getRootProps()" >
      <input v-bind="dropzone.getInputProps()" />
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M35.25 33H25.5V18.6216L30.4397 23.5603C30.7233 23.8297 31.1009 23.9777 31.4921 23.9727C31.8832 23.9677 32.2569 23.8101 32.5335 23.5335C32.8101 23.2569 32.9677 22.8832 32.9727 22.492C32.9777 22.1009 32.8297 21.7233 32.5603 21.4397L25.0603 13.9397C24.779 13.6586 24.3977 13.5007 24 13.5007C23.6023 13.5007 23.221 13.6586 22.9397 13.9397L15.4397 21.4397C15.1703 21.7233 15.0223 22.1009 15.0273 22.492C15.0323 22.8832 15.1899 23.2569 15.4665 23.5335C15.7431 23.8101 16.1168 23.9677 16.508 23.9727C16.8991 23.9777 17.2767 23.8297 17.5603 23.5603L22.5 18.6216V33H12.75C11.3581 32.9985 10.0236 32.4449 9.03933 31.4607C8.05509 30.4764 7.50149 29.1419 7.5 27.75V8.25C7.50149 6.85807 8.05509 5.52358 9.03933 4.53933C10.0236 3.55509 11.3581 3.00149 12.75 3H35.25C36.6419 3.00149 37.9764 3.55509 38.9607 4.53933C39.9449 5.52358 40.4985 6.85807 40.5 8.25V27.75C40.4985 29.1419 39.9449 30.4764 38.9607 31.4607C37.9764 32.4449 36.6419 32.9985 35.25 33ZM25.5 43.5C25.5 43.8978 25.342 44.2794 25.0607 44.5607C24.7794 44.842 24.3978 45 24 45C23.6022 45 23.2206 44.842 22.9393 44.5607C22.658 44.2794 22.5 43.8978 22.5 43.5V33H25.5V43.5Z" fill="#77818D"></path>
      </svg>
      <div class="download-form__text" id="file-text">
        {{ $t(label ?? 'labels.upload_files')}}
      </div>
    </div>
  </div>
</template>